// extracted by mini-css-extract-plugin
export default {"Backdrop":"Modal_Backdrop__iYJ1H","Modal":"Modal_Modal__ZZcE+","ModalHeader":"Modal_ModalHeader__jcp-5","ModalBody":"Modal_ModalBody__RHTpa"};